class Api {
  constructor(config) {
    this._url = config.url;
  }
  _check(res) {
    if (res.ok) {
      return res.json();
    } else {
      return Promise.reject("Произошла ошибка");
    }
  }
  getCardsUser() {
    return fetch(`${this._url}/cards`, {
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        return data;
      });
  }

  addCard({
    article,
    size,
    difficulty,
    colors,
    image,
    firstcolors,
    twocolors,
  }) {
    const formData = new FormData();

    formData.append("name", "ddd"); // Пример
    article && formData.append("article", article);
    size && formData.append("size", size);
    difficulty && formData.append("difficulty", difficulty);
    colors && formData.append("colors", colors);

    if (image) formData.append("image", image);
    if (firstcolors) formData.append("firstcolors", firstcolors);
    if (twocolors) formData.append("twocolors", twocolors);

    // Проверяем содержимое formData
    formData.forEach((value, key) => {
      console.log(key, value);
    });

    return fetch(`${this._url}/cards`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      credentials: "include",
      body: formData,
    })
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Ошибка: ${res.statusText}`);
        }
        return res.json();
      })
      .catch((err) => {
        console.error("Ошибка при отправке данных:", err);
        throw err;
      });
  }

  patchCard(
    { article, size, difficulty, colors, image, firstcolors, twocolors },
    id
  ) {
    const formData = new FormData();
    formData.append("name", "ddd"); // Пример
    article && formData.append("article", article);
    size && formData.append("size", size);
    difficulty && formData.append("difficulty", difficulty);
    colors && formData.append("colors", colors);

    if (image) formData.append("image", image);
    if (firstcolors) formData.append("firstcolors", firstcolors);
    if (twocolors) formData.append("twocolors", twocolors);

        // Проверяем содержимое formData
        formData.forEach((value, key) => {
          console.log(key, value);
        });

    return fetch(`${this._url}/cards/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      credentials: "include",
      body: formData, // Используем formData для отправки файла
    }).then((res) => {
      return this._check(res);
    });
  }

  deleteCard(ids) {
    return fetch(`${this._url}/cards`, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      body: JSON.stringify({
        ids: Array.isArray(ids) ? ids : [ids], // Проверяем, массив ли ids, и приводим к массиву, если это не так
      }),
    }).then((res) => {
      return this._check(res);
    });
  }

  download(id, type) {
    return fetch(`${this._url}/cards/download/${id}?type=${type}`, {
        method: "GET",
        credentials: "include",
        headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        },
    }).then((res) => {
        if (!res.ok) {
            throw new Error(`Ошибка ${res.status}: ${res.statusText}`);
        }
        return res.blob(); // <-- Получаем бинарные данные (blob)
    });
}

}

const api = new Api({
  url: "https://vandalvisionteam-vandalvision-servernew-8cf3.twc1.net/api",
});

export default api;
